import { mapValues } from 'lodash';
import { WordCloudPinLayoutTemplate, WordCloudTeacherPin } from '../../models';
import { PinCreationParams } from './pin-helper-types';

export const newWordCloudPin = (layoutTemplate: WordCloudPinLayoutTemplate): PinCreationParams<WordCloudTeacherPin> => {
  const basePin: PinCreationParams<WordCloudTeacherPin> = {
    type: 'WORD_CLOUD',
    settings: {
      layout: layoutTemplate.key,
      backgroundColor: layoutTemplate.backgroundColor,
      backgroundImage: layoutTemplate.backgroundImage,
      questionId: layoutTemplate.layoutParts.TITLE?.id,
      layoutParts: mapValues(layoutTemplate.layoutParts, (comp) => comp?.id),
    },
    teacherSettings: {},
    pinComponents: [...Object.values(layoutTemplate.layoutParts), ...layoutTemplate.pinComponents],
  };

  if ('backgroundTransparency' in layoutTemplate && layoutTemplate.backgroundTransparency !== undefined) {
    basePin.settings.backgroundTransparency = layoutTemplate.backgroundTransparency;
  }

  return basePin;
};
